<template>
    <v-container>
        <v-row align="center" justify="center">
            <template v-if="message">
                {{message}}
            </template>
            
            <v-col v-else class="col-12" align="center" justify="center">
                <i class="fas fa-spinner fa-5x fa-spin" style="color:green;"></i>
                <br><br>
                {{status}} 
            </v-col>
            
        </v-row>
    </v-container>
</template>
<script>
import {wrikeAuthUrl} from '../api'
export default {
    data(){
        return {
            message: null,
            status: 'Logging inn'
        }
    },
    methods:{
        login: () => {
            console.log("Resetting apiKey")
            localStorage.removeItem('apiKey')
            window.open(wrikeAuthUrl, 'login', 'scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=400,height=600,left=100,top=100')
            return
        }
    },
    mounted(){
        window.addEventListener("storage", (e) => {
            if(e.key != 'apiKey') return // we ignore other events
            if(!e.newValue) return // we ignore when we set it to null
            console.log(this.$router)
            //TODO: find out how to redirect to redir param.
            if(this.$route.query && this.$route.query.redir) this.$router.push(this.$route.query.redir)
            else this.$router.push('/')
        })
        this.login()
    }
}
</script>